import { Link } from 'react-router-dom';
import { events, featuredEvent, isEventPast } from './eventsData';
import { pastEvents } from './pastEventsData';
import PageHeader from './PageHeader';
import SnailOnly from './SnailOnly';
import './PastEvents.css';

export default function PastEvents() {
  // Events and the featured retreat "move" into this archive automatically once their
  // endDate elapses, rather than needing to be manually copied into pastEventsData.js.
  const autoExpired = [
    ...(isEventPast(featuredEvent) ? [featuredEvent] : []),
    ...events.filter(ev => ev.slug !== featuredEvent.slug && isEventPast(ev)),
  ].sort((a, b) => new Date(b.endDate) - new Date(a.endDate));
  const allPastEvents = [...autoExpired, ...pastEvents];

  return (
    <div className="pe-page" style={{ backgroundImage: 'linear-gradient(rgba(18,26,12,0.6), rgba(18,26,12,0.6)), url(/backgrounds/past-events-bg.jpg)' }}>
      <PageHeader />
      <SnailOnly className="snail-watermark" />
      <div className="pe-header">
        <Link to="/" className="pe-back">&larr; Back to home</Link>
      </div>
      <div className="pe-hero">
        <p className="pe-eyebrow">Archive</p>
        <h1 className="pe-title">Past Events</h1>
      </div>
      <div className="pe-body">
        <div className="event-cards pe-cards">
          {allPastEvents.map(ev => (
            <Link to={`/events/${ev.slug}`} key={ev.slug} className="event-card event-card--link">
              <img
                className="event-card-img"
                src={ev.img}
                alt={ev.title}
                style={ev.imgPosition ? { objectPosition: ev.imgPosition } : undefined}
              />
              <div className="event-card-body">
                <p className="event-card-date">{ev.date}</p>
                <h3>{ev.title}</h3>
                <span className="btn event-card-book-btn event-card-book-btn--sold-out">Event Passed</span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}
